<template>
	<form @submit.prevent="save">
		<div v-if="!isSurveyor">
			<smart-input name="status_description" :rows="1" :textarea="true" :label="label" v-model="selectedItem"></smart-input>
		</div>
		<div v-if="isSurveyor">
			<h2>{{label}}</h2>
			<v-combobox name="surveyor_private_msg" :items="options" item-text="text" v-model="selectedItem" item-value="id"></v-combobox>
			<smart-input name="status_description" :textarea="true" :label="$t('pages.cancelReasons.addPrivateMsg')" v-model="privateNote"></smart-input>
			<input type="file" multiple name="photos[]">
		</div>

		<v-btn :loading="inProgress" type="submit">{{$t("attributes.save")}}</v-btn>
	</form>

</template>

<script>

	import {types} from "src/store/modules/Measurement.module";
	import {types as statusTypes} from "dev/helpers/StatusManager";
	import json from "src/lists/cancel-list";

	export default {
		name: "cancel-select",
		props: {measurements: Array, isSurveyor: Boolean},
		data() {
			return {
				inProgress: false,
				selectedItem: null,
				privateNote: null,
			};
		},

		computed: {
			label() {
				if (this.isSurveyor) {
					return this.$t("cancelReasons.pleaseChooseFromList");
				} else
					return this.$t("cancelReasons.pleaseNoteReason");
			}
		},

		methods: {
			async save(e) {
				if (!this.selectedItem) {
					swal.fire(this.$t("cancelReasons.pleaseNoteReason"));
					return;
				}
				let form = new FormData(e.target);
				this.measurements.forEach(m=>form.append("ids[]",m));
				this.inProgress = true;
				await this.$store.dispatch(types.CANCEL, form);
				/*
				await this.$store.dispatch(types.CANCEL, {
					ids: this.measurements,
					surveyor_private_msg: this.privateNote,
					status_description: this.selectedItem
				});
*/
				this.inProgress = false;
				this.$emit("closeDialog");

			},

		},

		created() {
			if (this.isSurveyor) {
				this.options = json.sort();
			}
		}

	};
</script>

<style scoped>

</style>
